import config from '../../../config';

const apiV1Url = config.apiUrl();
const operationsUrl = `${apiV1Url}/BackOffice/Operations`;

export default {
  uploadCapeTownImportFile: (): string => `${operationsUrl}/tmt-capetown-upload`,
  uploadTmtFinesImportFile: (): string => `${operationsUrl}/tmt-fines-upload`,
  uploadPayFastImportFile: (): string => `${operationsUrl}/payfast-email-upload`,
  uploadInvalidEmailImportFile: (): string => `${operationsUrl}/invalid-email-upload`,
  uploadBulkImportFile: (): string => `${operationsUrl}/bulk-fines-upload`,
  exportWeeklyTmtCapeTown: (): string => `${operationsUrl}/export-coct`,
};
